import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { SquareImage } from '@components/main-components/image/BaseImage';
import { PlayButton } from '@components/main-components/play-button/PlayButton';

export const CoverImagePlayButton = ({
  coverImageUrl,
  title,
  isPlaying,
  onPlayClick,
  isLoading,
  className,
  playButtonSize = 'm',
}: {
  coverImageUrl: string;
  title: string;
  isPlaying: boolean;
  onPlayClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading: boolean;
  className?: string;
  playButtonSize?: React.ComponentProps<typeof PlayButton>['size'];
}) => {
  return (
    <div
      className={twMerge(
        'group relative mr-2 h-12 w-12 flex-shrink-0 overflow-hidden rounded-md',
        className,
      )}
    >
      <SquareImage size={48} borderRadius={8} src={coverImageUrl} alt={title} />
      <PlayButton
        className={clsx(
          'absolute left-0 top-0 transition-all duration-300 ease-in-out group-hover:visible',
          isPlaying ? 'visible' : 'lg:invisible',
        )}
        onClick={onPlayClick}
        size={playButtonSize}
        playing={isPlaying}
        loading={isLoading}
        color="transparent"
      />
    </div>
  );
};
